export default {
  Title: 'Tham số báo cáo',
  Year: 'Năm',
  ViewReport: 'Xem báo cáo',
  ChoosePeriod: 'Chọn kỳ báo cáo',
  FromDate: 'Từ ngày',
  ToDate: 'Đến ngày',
  PrintAdjustMonth: 'In tháng chỉnh lý quyết toán',
  IncludeAdjustVoucher: 'Bao gồm chứng từ chỉnh lý quyết toán',
  PrintSummaryAccount: 'In theo tài khoản tổng hợp',
  PrintA3Page: 'In theo khổ A3',
  ConfirmViewReport: 'Xem báo cáo',
  BookCover: 'In kèm bìa sổ'
};
